import { useCallback, useEffect, useMemo, useState } from "react";

import type { AddressBookItemSummary } from "~/shared/schemas/address-book-schema.ts";

export type SelectDescriptor = Record<number, boolean>;

type UseAddressSelectionProps = {
	data: AddressBookItemSummary[];
	showModal: boolean;
};

export function useAddressSelection({
	data,
	showModal,
}: UseAddressSelectionProps) {
	const [select, setSelect] = useState<SelectDescriptor>({});

	useEffect(() => {
		if (!showModal) {
			setSelect({});
		}
	}, [showModal]);

	const selectedItems = useMemo(
		() => data.filter((d) => select[d.addressBookItemId]),
		[select, data],
	);

	const handleSelect = useCallback((id: string | number) => {
		// For single select, clear all and select only this one
		const newSelection: SelectDescriptor = {};
		newSelection[id as number] = true;
		setSelect(newSelection);
	}, []);

	const handleDeselect = useCallback((id: string | number) => {
		// Deselect this one
		setSelect((prev) => ({ ...prev, [id as number]: false }));
	}, []);

	return {
		select,
		selectedItems,
		handleSelect,
		handleDeselect,
	};
}
